import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Sat Sep 08 2018
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import * as React from 'react';
import { ValidationLevel, Utils } from '@logio/common-be-fe';
import { Key } from '../../../../../shared/keyboard/Key';
import { observable, action } from 'mobx';
/**
 * Abstract class for all the AgGrid editors. Every editor should extend it
 */

var CellEditor =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CellEditor, _React$Component);

  function CellEditor(props) {
    var _this;

    _classCallCheck(this, CellEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CellEditor).call(this, props)); // LOG-3758

    _this.updatingDone = false;
    /**
     * Prevents stoping editation if value is invalid
     * Starts editing bellow cell after enter
     * Provides tab navigation
     * @author VBr
     * @author LZe
     */

    _this.handleNavigation = function (e) {
      // This jump to cell bellow and starts editing it on enter ( but not for bulk row )
      if (e.key === Key.Enter && !_this.props.context.store.invalid) {
        // can't use just enterMovesDownAfterEdit - it doesn't start editing of the next cell (just focus)
        _this.props.api.stopEditing();

        _this.props.api.clearRangeSelection();

        if (_this.props.node.rowPinned !== 'top') {
          if (_this.props.rowIndex + 1 <= _this.props.api.getModel().getPageLastRow()) {
            _this.props.api.setFocusedCell(_this.props.rowIndex + 1, _this.props.column.getId());

            _this.props.api.startEditingCell({
              rowIndex: _this.props.rowIndex + 1,
              colKey: _this.props.column.getId()
            });
          } else {
            //last row cell doesn't lose focus after enter key press
            _this.props.api.setFocusedCell(_this.props.rowIndex, _this.props.column.getId());
          }
        } else {
          _this.props.api.setFocusedCell(_this.props.rowIndex, _this.props.column.getId(), 'top');
        }
      } // The value cannot be longer invalid because we're throwing it away


      if (e.key === Key.Escape) {
        _this.props.context.store.setValid(false);
      }
    };

    _this.colDef = _this.props.column.getColDef();
    _this.state = _this.initialState();
    _this.wrapper = React.createRef();
    return _this;
  }

  _createClass(CellEditor, [{
    key: "initialState",
    value: function initialState(definedValue) {
      return {
        value: Utils.isValueMissing(definedValue) ? this.props.value : definedValue,
        validationError: null
      };
    }
  }, {
    key: "validate",
    value: function validate(value) {
      return this.colDef.schema.validate(value, ValidationLevel.Fast);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addEventListeners();

      if (this.colDef.onEditStart) {
        this.colDef.onEditStart(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Removes event listener to prevent leaving invalid input
      this.removeEventListeners();

      if (this.colDef.onEditEnd) {
        this.colDef.onEditEnd(this.props);
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      this.wrapper.current.addEventListener('keydown', this.handleNavigation, false);
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      this.wrapper.current.removeEventListener('keydown', this.handleNavigation);
    }
    /**
     * AgGrid method - Return the DOM element of your editor, this is what the grid puts into the DOM
     */

  }, {
    key: "getGui",
    value: function getGui() {
      return this.wrapper.current;
    }
    /**
     * AgGrid method - Should return the final value to the grid, the result of the editing
     */

  }, {
    key: "getValue",
    value: function getValue() {
      var _this2 = this;

      var validationResult = this.validate(this.state.value); // const isBulk = this.props.context.store.showBulkRow && this.props.rowIndex === 0 && this.props.value === '';
      // const isBulk = this.props.context.store.showBulkRow && this.props.node.rowPinned === 'top';

      var isBulk = this.props.node.rowIndex === 0 && this.props.node.rowPinned === 'top';
      var bulkAction = this.colDef.bulkFunc;
      var actionFunc = isBulk && bulkAction ? bulkAction : this.colDef.action;

      if (actionFunc && validationResult.valid && validationResult.get() !== this.props.value && this.props.value !== this.state.value
      /* FIXME: !== according to the value type */
      ) {
          this.props.eGridCell.classList.remove('is-loading-ok', 'is-loading-error');
          this.props.eGridCell.classList.add('is-loading'); // Get validated value

          var validatedValue = validationResult.get(); // Set empty string value to null

          if (Utils.isString(validatedValue) && !validatedValue.length) {
            validatedValue = null;
          }

          var colId = this.props.column.getId(); // Call the backend to update the value

          actionFunc(this.props.node.id, colId, validatedValue).then(function (value) {
            _this2.props.eGridCell.classList.replace('is-loading', 'is-loading-ok');
          }, function (error) {
            _this2.props.eGridCell.classList.replace('is-loading', 'is-loading-error');
          }).then(function () {
            if (isBulk) {
              // FIXME: we should update just all cells in specific column
              // this.props.api.redrawRows(); // LOG-2506
              _this2.props.api.refreshCells({
                columns: [colId]
              });
            }

            _this2.setUpdatingDone(); // LOG-3758

          });

          if (isBulk) {
            // we need to update all cells in specific column
            this.props.api.forEachNode(function (node) {
              return node.setDataValue(colId, validatedValue);
            });
          }

          return validatedValue;
        }

      if (validationResult.valid) {
        return validationResult.get();
      }

      return this.props.value;
    } // LOG-3758

  }, {
    key: "setUpdatingDone",
    value: function setUpdatingDone() {
      this.updatingDone = true;
    } // LOG-3758

  }, {
    key: "setUpdatingDoneDefault",
    value: function setUpdatingDoneDefault() {
      this.updatingDone = false;
    }
    /**
     * AgGrid method - Gets called once after GUI is attached to DOM.
     * Useful if you want to focus or highlight a component
     * (this is not possible when the element is not attached)
     */

  }, {
    key: "afterGuiAttached",
    value: function afterGuiAttached() {
      // Get focus to our input
      var input = this.wrapper.current.querySelector('input');

      if (input) {
        input.focus();
      }
    }
    /**
     * Validates passed data and updates the state of the component
     * @param data
     */

  }, {
    key: "updateValue",
    value: function updateValue(data) {
      var validationResult = this.validate(data);
      var validationError = validationResult.valid ? null : validationResult;
      this.props.context.store.setValid(!!validationError);
      this.setState({
        value: data,
        validationError: validationError
      });
    }
  }]);

  return CellEditor;
}(React.Component);

export { CellEditor as default };

__decorate([observable, __metadata("design:type", Boolean)], CellEditor.prototype, "updatingDone", void 0);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], CellEditor.prototype, "setUpdatingDone", null);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], CellEditor.prototype, "setUpdatingDoneDefault", null);